export default __webpack_public_path__ + "static/media/client-like.8550be21.png";